module.exports = __webpack_public_path__ + "media/xs-student-intro.72c8a197.mp4";